import '../styles/DurationSelector.css'

interface DurationSelectorProps {
  selectedDuration: number | null
  onSelect: (duration: number) => void
}

export function DurationSelector({ selectedDuration, onSelect }: DurationSelectorProps) {
  const durations = [
    { days: 1, label: 'день' },
    { days: 2, label: 'дня' },
    { days: 3, label: 'дня' }
  ]

  return (
    <div className="duration-selector">
      <div className="duration-grid">
        {durations.map(({ days, label }) => (
          <button
            key={days}
            className={`duration-button ${selectedDuration === days ? 'selected' : ''}`}
            onClick={() => onSelect(days)}
            aria-pressed={selectedDuration === days}
          >
            {days} {label}
          </button>
        ))}
      </div>
    </div>
  )
}